import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import {
  FORM_FILTERS_ROLE,
  ROLES_ACCESS,
  ROLE_CONSTANTS,
  ROLE_SECONDARY_FILTERS,
  SEARCH_CONTEXT_DESCRIPTIONS
} from "./constants/RoleConstants";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import SaveRole from "@/modules/Roles/components/SaveRole/SaveRole.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import {
  CHART_TYPES,
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { FORM_TEMP_CONSTANTS } from "../FormTemplate/constants/FormTemplateConstants";
import { RolesService } from "@/modules/Roles/services/RolesService";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { CrudChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/CrudChartRenderData";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { Http } from "@status/codes";
import { Utils } from "@/shared/utils/utils";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SearchContext } from "@/shared/models/SearchContext";
import store from "@/store";
import { QuerySearchRole } from "./models/QuerySearchRole";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";

import { NavigationGuardNext, Route } from "vue-router";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { AxiosError } from "axios";
Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "Roles",
  components: {
    EmptyState,
    ScrollBottom,
    ObservationModal,
    ModalTemplate,
    ListItem,
    SaveRole,
    CrudChart
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Roles extends Vue {
  @Inject() rolesService!: RolesService;

  TITLE_PAGE = ROLE_CONSTANTS.PAGE_TITLE;

  dataToMainView!: MenuDataStructure;
  filterArray: Filter[] = FORM_FILTERS_ROLE;
  OPERATIONS: string[] = [];
  querySearch?: QuerySearchRole = {};
  filterQuery: QuerySearchRole = {};
  admin = false;

  idRole = "";
  idRoleFirst = "";

  GRAPH_ROL = ROLE_CONSTANTS.GRAPH;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  isVisibleSaveRole = false;
  infoGroupChartData: CrudChartRenderData = CHART_INIT;
  isLoadingCharts = false;
  showCharts = false;
  chartType: string = CHART_TYPES[0].value;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;

  listRoles: RoleInfo[] = [];
  responseData?: CrudChartData;

  mounted() {
    this.TITLE_PAGE = ROLE_CONSTANTS.PAGE_TITLE;
    this.isAdmin();
    this.getDataChart();
    this.emitSearchInitializer();
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  private isAdmin(): void {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);
    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
      this.filterArray[0].secondaryFilters = [...ROLE_SECONDARY_FILTERS];
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.ROLE
    );
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataChart();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
      }
    }
  }

  onButtonAdd() {
    this.addFormRole("", FORM_TEMP_CONSTANTS.CREAR_FORMULARIO);
  }

  addFormRole(id: string, action: string) {
    if (action === FORM_TEMP_CONSTANTS.CREAR_FORMULARIO) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.showFormRole(true);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
        this.TITLE_PAGE = ROLE_CONSTANTS.ADD_PAGE_TITLE;
      } else {
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
      }
      return;
    }
  }

  showFormRole(val: boolean) {
    this.isVisibleSaveRole = val;
  }

  get currentIcon() {
    return !this.isVisibleSaveRole
      ? GENERAL_CONSTANTS.ICONS.ADD
      : GENERAL_CONSTANTS.ICONS.CANCEL;
  }

  get currentTooltip() {
    return !this.isVisibleSaveRole
      ? ROLE_CONSTANTS.BUTTON.ADD_ROLE
      : ROLE_CONSTANTS.BUTTON.CLOSE_ROLE;
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async emitSearchInitializer() {
    const searchContext: SearchContext = {
      title: ROLE_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: this.filterArray,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.ROLE,
      descriptions: SEARCH_CONTEXT_DESCRIPTIONS,
      optionsToFilter: [],
      textButtonCreate: ROLE_CONSTANTS.BUTTON.ADD_ROLE
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  getFilterQuery(): QuerySearchRole {
    const filterQuery: QuerySearchRole = {};
    if (this.querySearch?.idRole) {
      filterQuery.idRole = this.querySearch.idRole;
    }
    if (this.querySearch?.state) filterQuery.state = this.querySearch.state;
    if (this.querySearch?.name) filterQuery.name = this.querySearch.name;
    filterQuery.chart = "true";
    return filterQuery;
  }

  updateDataGraph(data: CrudChartData) {
    this.infoGroupChartData = {
      chartTitle: this.GRAPH_ROL.TITLE,
      chartRenderData: Utils.mapChartData(data, this.GRAPH_ROL.NAME_KEY_DATA)
    };
  }

  async getDataChart() {
    this.isLoadingCharts = true;
    this.showCharts = false;
    try {
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
      );
      const response = await this.rolesService.getRolesByFiltersArrays(
        this.getFilterQuery()
      );
      if (response.code === Http.Found && response.data != undefined) {
        this.updateDataGraph(response.data);
        this.responseData = response.data;
        this.showCharts = true;
        if (Array.isArray(response.data["roleList"])) {
          this.listRoles = (response.data["roleList"] as unknown) as RoleInfo[];
          this.listRoles.sort(role => (role.id == this.idRoleFirst ? -1 : 0));
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
            this.listRoles
          );
        }
      } else {
        this.infoGroupChartData = CHART_INIT;
        this.showCharts = false;
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
        if (response.code === Http.NotFound) {
          Snackbar.popInfo(response.message);
        } else {
          Snackbar.popError(response.message);
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.infoGroupChartData = CHART_INIT;
      this.showCharts = false;
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
    }
    this.isLoadingCharts = false;
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editRole(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.deleteRole(itemId);
        this.closeRole();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateRoleById(itemId, STATE.ACTIVE);
        this.closeRole();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateRoleById(itemId, STATE.INACTIVE);
        this.closeRole();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.closeRole();
        break;
    }
  }

  async updateStateRoleById(id: string, state: string) {
    try {
      const responseData = await this.rolesService.updateStateRoleById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.getDataChart();
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteRole(id: string) {
    try {
      const responseData = await this.rolesService.deleteRole(id);

      if (this.idRole == id) {
        this.closeRole();
      }
      if (responseData.code === Http.Ok) {
        this.getDataChart();
        Snackbar.popSuccess(responseData.message);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(ROLE_CONSTANTS.MESSAGES.ROLE_USED);
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  editRole(idRole: string) {
    this.showSaveRole(idRole);
  }

  showSaveRole(idRole: string) {
    this.TITLE_PAGE = ROLE_CONSTANTS.EDIT_PAGE_TITLE;
    this.idRole = idRole;
    this.showFormRole(true);
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      idRole
    );
  }

  async closeRole() {
    this.TITLE_PAGE = ROLE_CONSTANTS.PAGE_TITLE;
    this.idRole = "";
    this.showFormRole(false);
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.UNDO_SELECTED_ITEM
    );
    this.getDataChart();
  }

  async clickData(label: string) {
    const role = this.listRoles.find(role => role.name.trim() == label);
    if (role) {
      await this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        [role]
      );
      const roleChartInfo: any = {};
      roleChartInfo[role.name] = 1;
      this.updateDataGraph(({
        roleChartInfo,
        roleList: [role]
      } as unknown) as CrudChartData);
    }
  }

  async clickOut() {
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
      this.listRoles
    );
    if (this.responseData) {
      this.updateDataGraph(this.responseData);
    }
  }
}
